import { mesaColorNames } from '@/src/common/theme'
import { StyleSheet } from 'react-native'

export const cardApplicationStyles = StyleSheet.create({
  headerText: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 32,
  },
  instructionText: {
    marginVertical: 16,
    marginBottom: 32,
    lineHeight: 24,
    color: mesaColorNames['Greyscale/400 #A4AAAC'],
  },
  returnHomeButtonStyles: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
  },
  returnHomeTitleStyles: {
    color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
  },
})
